export { default } from './CustomHead';
